export default "__VITE_ASSET__uDDL6io9__"